import { customerServiceManager } from '~/components/Chat/customerServiceManager';

export const SupportTips = () => {
  const handleSupport = () => {
    customerServiceManager.open();
  };
  return (
    <>
      <p class="text-neutral-main2 text-center">
        {t("We couldn't place your bet. Please try again or contact ")} &nbsp;
        <span onClick={handleSupport} class="underline cursor-pointer text-brand-default">
          {t(' Player Support')}
        </span>
      </p>
    </>
  );
};
